import * as React from 'react';
import { Subheading } from 'components/src/typography';
import { NewsArticleEntryFieldsFragment } from '../../../@types/generated';
import Label from 'components/src/label';
import { ImageWithFocalPoint } from '@/components/ImageWithFocalPoint';
import Link from 'next/link';
import { getOr } from '@/utils/options';
import clsx from 'clsx';

type Props = {
  sectionTitle?: string;
  item?: NewsArticleEntryFieldsFragment;
};

const NewsEntry = ({ sectionTitle, item }: Props) => {
  if (!(item && item.title)) return null;

  return (
    <div className="col-span-12 flex flex-col md:col-span-4">
      <Link
        href={{
          pathname: '/frettir/[slug]',
          query: { slug: getOr(item.slug, '') },
        }}
        className="space-y-16"
      >
        <div className="relative aspect-square">
          {item.heroImage && (
            <ImageWithFocalPoint
              image={item.thumbnailImage ? item.thumbnailImage : item.heroImage}
              sectionId={sectionTitle}
              className="rounded-28"
              sizes={{ default: '400px' }}
            />
          )}
        </div>
        <div
          className={`flex gap-8 ${clsx({
            '!h-24': item?.tagsCollection?.items,
          })}`}
        >
          {item?.tagsCollection?.items.map((tag) => {
            return (
              tag?.title && (
                <Label
                  key={`${sectionTitle}-${item.title}-tag-${tag.title}`}
                  label={tag.title}
                  type="pill"
                  colorVariant="red"
                />
              )
            );
          })}
        </div>
        <Subheading classes="justify-self-start" bold>
          {item.title}
        </Subheading>
      </Link>
    </div>
  );
};
export default NewsEntry;
